// Questionnaire definition. Option `value` keys MUST match backend safety.build_questionnaire_bullets.
export const GOAL_OPTIONS = [
  { value: "luminosita", label: "Maggiore luminosità" },
  { value: "uniformita", label: "Incarnato più uniforme" },
  { value: "imperfezioni", label: "Ridurre la visibilità delle imperfezioni" },
  { value: "pori", label: "Migliorare l'aspetto dei pori" },
  { value: "eta", label: "Lavorare sui segni visibili dell'età" },
  { value: "comfort", label: "Maggiore comfort" },
  { value: "rossore", label: "Ridurre l'aspetto del rossore" },
  { value: "non_saprei", label: "Non saprei" },
];

export const QUESTIONS = [
  {
    id: "q1", type: "single", title: "Qual è la tua fascia d'età?",
    options: [
      { value: "lt25", label: "Meno di 25" },
      { value: "25_34", label: "25–34" },
      { value: "35_44", label: "35–44" },
      { value: "45_54", label: "45–54" },
      { value: "55_64", label: "55–64" },
      { value: "65_plus", label: "65+" },
    ],
  },
  {
    id: "q2", type: "single", title: "Come senti la pelle subito dopo la detersione?",
    options: [
      { value: "tira_molto", label: "Tira molto" },
      { value: "tira_leggermente", label: "Tira leggermente" },
      { value: "confortevole", label: "È confortevole" },
      { value: "lucida", label: "Tende a lucidarsi rapidamente" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q3", type: "single", title: "Durante la giornata noti lucidità?",
    options: [
      { value: "quasi_mai", label: "Quasi mai" },
      { value: "zona_t", label: "Prevalentemente nella zona T" },
      { value: "diverse_zone", label: "In diverse zone del viso" },
      { value: "molto_facilmente", label: "Molto facilmente" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q4", type: "single", title: "La tua pelle tende a reagire ai cosmetici?",
    options: [
      { value: "raramente", label: "Raramente" },
      { value: "occasionalmente", label: "Occasionalmente" },
      { value: "spesso", label: "Spesso" },
      { value: "molto_facilmente", label: "Molto facilmente" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q5", type: "single", title: "Noti rossore nella vita quotidiana?",
    subtitle: "Questa è un'informazione riferita da te.",
    options: [
      { value: "quasi_mai", label: "Quasi mai" },
      { value: "occasionalmente", label: "Occasionalmente" },
      { value: "frequentemente", label: "Frequentemente" },
      { value: "molto_frequentemente", label: "Molto frequentemente" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q6", type: "single", title: "Quanto frequentemente compaiono imperfezioni?",
    options: [
      { value: "quasi_mai", label: "Quasi mai" },
      { value: "occasionalmente", label: "Occasionalmente" },
      { value: "frequentemente", label: "Frequentemente" },
      { value: "molto_frequentemente", label: "Molto frequentemente" },
    ],
  },
  { id: "q7", type: "single", title: "Qual è il risultato cosmetico che desideri maggiormente?", options: GOAL_OPTIONS },
  {
    id: "q8", type: "single", title: "C'è un secondo obiettivo importante per te?",
    options: [...GOAL_OPTIONS.filter((o) => o.value !== "non_saprei"), { value: "nessuno_secondo", label: "Nessun secondo obiettivo" }],
  },
  {
    id: "q9", type: "single", title: "Quanto spesso utilizzi una protezione solare sul viso?",
    options: [
      { value: "ogni_giorno", label: "Ogni giorno" },
      { value: "quasi_ogni_giorno", label: "Quasi ogni giorno" },
      { value: "primavera_estate", label: "Soprattutto in primavera e in estate" },
      { value: "raramente", label: "Raramente" },
      { value: "mai", label: "Mai" },
    ],
  },
  {
    id: "q10", type: "multi", title: "Quali attivi cosmetici utilizzi già?",
    subtitle: "Puoi selezionare più opzioni.",
    options: [
      { value: "vitamina_c", label: "Vitamina C" },
      { value: "retinolo", label: "Retinolo / retinoidi cosmetici" },
      { value: "aha_bha_pha", label: "AHA / BHA / PHA" },
      { value: "niacinamide", label: "Niacinamide" },
      { value: "acido_ialuronico", label: "Acido ialuronico" },
      { value: "antimacchia", label: "Prodotti antimacchia" },
      { value: "nessuno", label: "Nessuno" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q11", type: "single", title: "Come descriveresti normalmente la tua pelle?",
    options: [
      { value: "secca", label: "Secca" },
      { value: "normale", label: "Normale" },
      { value: "mista", label: "Mista" },
      { value: "grassa", label: "Grassa" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q12", type: "single", title: "Ti consideri anche sensibile?",
    options: [
      { value: "si", label: "Sì" },
      { value: "no", label: "No" },
      { value: "non_saprei", label: "Non saprei" },
    ],
  },
  {
    id: "q13", type: "single", title: "Quanti prodotti utilizzi abitualmente sul viso?",
    options: [
      { value: "nessuno", label: "Nessuno" },
      { value: "1_2", label: "1–2" },
      { value: "3_4", label: "3–4" },
      { value: "5_piu", label: "5 o più" },
    ],
  },
  {
    id: "q14", type: "text", title: "C'è qualcosa che la tua pelle tende a tollerare male?",
    subtitle: "Facoltativo · massimo 200 caratteri.", optional: true, maxLength: 200,
  },
];
